import { endOfMonth, subDays } from 'date-fns';

export const isDayOfLastWeekOfMonth = (date: Date): boolean => {
	const lastDayOfMonth = endOfMonth(date);
	const lastSevenDays: number[] = [];

	for (let i = 0; i < 7; i++) {
		const day = subDays(lastDayOfMonth, i);
		lastSevenDays.unshift(day.getDate());
	}

	return lastSevenDays.includes(date.getDate());
};
